//export const host = 'localhost'
export const host = 'request-desk.ru/api'
//export const port = ':8080/api'
export const port = ''
//export const secure = 'http'
export const secure = 'https'